<template>
  <div>
    <DashboardHeader title="Manage Post">
      <v-layout row wrap class="mt-4">
        <v-flex xs12 md5 class="mx-2">
          <v-btn
            :color="getThemeColor"
            dark
            class="mx-4"
            x-small
            rounded
            v-if="isStaff"
            @click="updateSelectedStatuses()"
            >Update On/Off Posts</v-btn
          >

          <v-btn
            color="red"
            dark
            class="mx-4"
            x-small
            rounded
            v-if="isStaff"
            @click="bulkDeletePosts()"
            >Bulk Delete</v-btn
          >
          <v-data-table
            :headers="headers"
            :items="posts"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.status="{ item }">
              <v-checkbox
                v-if="isStaff"
                class="shrink"
                :value="item.id"
                v-model="selectedStatuses"
              ></v-checkbox>
            </template>
            <template v-slot:item.id="{ item }">
              <v-icon
                @click="editPost(item)"
                v-if="isStaff || item.user.email == getCurrentUser.email"
                >mdi-pencil</v-icon
              >
              <v-checkbox
                v-if="isStaff || item.user.email == getCurrentUser.email"
                class="shrink"
                :value="item.id"
                v-model="selectedDeleteCandidates"
              ></v-checkbox>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex xs12 md6 class="mx-2">
          <v-text-field
            v-model="postTitle"
            label="Post Title"
            :rules="rules"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <v-row>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="postDate"
              transition="scale-transition"
              offset-y
              min-width="290px"
              class="mb-6"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="postDate"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  class="mx-3"
                ></v-text-field>
              </template>
              <v-date-picker v-model="postDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="emitSelectedDate()"
                  >OK</v-btn
                >
                <v-btn text color="red" @click="menu = false">Cancel</v-btn>
              </v-date-picker>
            </v-menu>

            <v-select
              class="mx-3"
              :items="statuses"
              label="Set Post Status"
              v-model="postStatus"
            ></v-select>
          </v-row>
          <vue-editor
            v-model="postBody"
            id="editor"
            v-if="isParentOrStudent || isStaff"
          />

          <WebsiteManageImageTiles
            :folder="'posts/' + getCurrentUser.emis + '/' + postFolder"
            v-if="isParentOrStudent || isStaff"
          ></WebsiteManageImageTiles>

          <v-btn
            color="primary"
            class="mt-4 mr-4"
            rounded
            dark
            @click="ResetForm()"
            >Reset Form</v-btn
          >
          <v-btn
            color="green accent-4"
            class="mt-4"
            rounded
            dark
            @click="savePost()"
            >Save Post</v-btn
          >
        </v-flex>
      </v-layout>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import WebsiteManageImageTiles from "@/components/SchoolWebsite/WebsiteManageImageTiles.vue";

export default {
  components: { DashboardHeader, WebsiteManageImageTiles },
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getPostBody() {
      return this.$store.getters.getPostBody;
    },
    isParentOrStudent() {
      return this.$store.getters.isParentOrStudent;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
  },
  mounted() {
    this.postFolder = axios.generateToken();

    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/get-all-posts-for-management", this.getAccessToken)
      .then((posts) => {
        posts.forEach((post) => {
          if (post.status == 1) {
            this.selectedStatuses.push(post.id);
          }
        });
        this.posts = posts;
        this.$store.commit("setLoader", false);
      });
  },
  data: () => ({
    menu: false,
    postFolder: null,
    editing: false,
    postId: 0,
    postTitle: null,
    postBody: "Type here ..",
    postDate: new Date().toISOString().substr(0, 10),
    postUserId: null,
    postStatus: null,
    selectedStatuses: [76],
    selectedDeleteCandidates: [],
    posts: [],
    headers: [
      {
        text: "Post Title",
        align: "start",
        value: "title",
      },
      { text: "Author", value: "user.name" },
      { text: "Date Created", value: "date_posted" },
      { text: "On/Off", value: "status" },
      { text: "Actions", value: "id" },
    ],
    rules: [(value) => !!value || "Required."],
    statuses: [
      { text: "On [Publish]", value: "on" },
      { text: "Off [Not Now]", value: "off" },
    ],
  }),
  methods: {
    getContent(content) {
      this.postBody = content;
    },
    updateSelectedStatuses() {
      if (confirm("Are you sure you want to Update Selected Posts?")) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/update-selected-posts-statuses",
            { postsIds: this.selectedStatuses },
            this.getAccessToken
          )
          .then((posts) => {
            posts.forEach((post) => {
              if (post.status == 1) {
                this.selectedStatuses.push(post.id);
              }
            });
            this.posts = posts;
            this.$store.commit("setLoader", false);
          });
      }
    },
    bulkDeletePosts() {
      if (this.selectedDeleteCandidates.length > 0) {
        if (confirm("Are you sure you want to Delete Selected Posts?")) {
          this.$store.commit("setLoader", true);
          axios
            .postDataWithToken(
              "/auth/bulk-delete-posts",
              { postsIds: this.selectedDeleteCandidates },
              this.getAccessToken
            )
            .then((posts) => {
              posts.forEach((post) => {
                if (post.status == 1) {
                  this.selectedStatuses.push(post.id);
                }
              });
              this.posts = posts;
              this.$store.commit("setLoader", false);
            });
        }
      } else {
        event.preventDefault();
        alert("Ÿou Must At Least Select One Post To Bulk Delete");
      }
    },
    editPost(item) {
      this.postBody = item.body;
      this.postTitle = item.title;
      this.postDate = item.date_posted;
      this.postStatus = item.status;
      this.postId = item.id;
      if (item.picture_folder == "noPicture") {
        this.postFolder = axios.generateToken();
      } else {
        this.postFolder = item.picture_folder;
      }
    },
    savePost() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-post",
          {
            body: this.postBody,
            title: this.postTitle,
            datePosted: this.postDate,
            status: this.postStatus,
            pictureFolder: this.postFolder,
            postId: this.postId,
          },
          this.getAccessToken
        )
        .then((posts) => {
          posts.forEach((post) => {
            if (post.status == 1) {
              this.selectedStatuses.push(post.id);
            }
          });
          this.posts = posts;
          this.$store.commit("setLoader", false);
        });
    },
    ResetForm() {
      this.postBody = "Type here ..";
      this.postTitle = null;
      this.postDate = new Date().toISOString().substr(0, 10);
      this.postStatus = null;
      this.postFolder = axios.generateToken();
      this.postId = 0;
    },
    emitSelectedDate() {
      this.$refs.menu.save(this.postDate);
    },
  },
};
</script>

<style></style>
